import { Button } from '@azelis/ui/components/button';
import { TabsList, TabsTrigger } from '@azelis/ui/components/tabs';

import type { SharePointDocument } from '@/api/types';

import { DocumentsColumn } from './documents-column';

/** Left column: pick which drive (SharePoint document library) to browse. */
export function ProductDocumentsColumn({
  allIds,
  allSelected,
  drives,
  grouped,
  onToggleAll,
}: {
  allIds: Array<string>;
  allSelected: boolean;
  drives: Array<string>;
  grouped: Map<string, Array<SharePointDocument>>;
  onToggleAll: (ids: Array<string>) => void;
}) {
  return (
    <DocumentsColumn
      action={
        <Button
          disabled={allIds.length === 0}
          type="button"
          onClick={() => {
            onToggleAll(allIds);
          }}
        >
          {allSelected ? 'Deselect all' : 'Select all'}
        </Button>
      }
      className="w-[240px] shrink-0"
      title="Product Documents"
    >
      <TabsList className="h-auto w-full flex-col items-stretch gap-4 bg-transparent p-[3px]">
        {drives.map((drive) => (
          <TabsTrigger key={drive} className="h-8 w-fit flex-none justify-start" value={drive}>
            {drive} ({grouped.get(drive)?.length ?? 0})
          </TabsTrigger>
        ))}
      </TabsList>
    </DocumentsColumn>
  );
}
